/**
 * lib/operationalPalette.js — restrained, field-readable colours for the
 * operational overlay system.
 *
 * NO neon. NO rainbow GIS chaos. NO glowing cyberpunk garbage. Inspired by
 * airfield operational schemas + FAA coordination prints.
 */
export const LAYER_PALETTE = {
  storm:       { stroke: "rgba(56, 189, 248, 0.92)",  fill: "rgba(56, 189, 248, 0.18)", swatch: "#38bdf8" }, // restrained cyan
  sanitary:    { stroke: "rgba(74, 222, 128, 0.92)",  fill: "rgba(74, 222, 128, 0.18)", swatch: "#4ade80" }, // muted green
  water:       { stroke: "rgba(96, 165, 250, 0.92)",  fill: "rgba(96, 165, 250, 0.18)", swatch: "#60a5fa" }, // restrained blue
  electrical:  { stroke: "rgba(251, 191, 36, 0.92)",  fill: "rgba(251, 191, 36, 0.18)", swatch: "#fbbf24" }, // soft amber
  grading:     { stroke: "rgba(217, 119, 87,  0.92)", fill: "rgba(217, 119, 87,  0.16)", swatch: "#d97757" }, // muted earth/orange
  paving:      { stroke: "rgba(148, 163, 184, 0.92)", fill: "rgba(148, 163, 184, 0.20)", swatch: "#94a3b8" }, // restrained asphalt gray
  work_limits: { stroke: "rgba(217, 70, 132,  0.92)", fill: "rgba(217, 70, 132,  0.10)", swatch: "#d94684" }, // subtle magenta/red
};

export const CONFLICT_PALETTE = {
  normal:              { ring: null,                       label: "" },
  conflict:            { ring: "rgba(239, 68, 68, 0.95)",  label: "CONFLICT" },         // restrained red ring
  needs_verification:  { ring: "rgba(234, 179, 8, 0.90)",  label: "NEEDS VERIFICATION" }, // warm amber ring
};

/** Structure-type → glyph kind. Drives the SVG marker shape. */
export const STRUCTURE_GLYPH = {
  storm_manhole: "circle",   // filled circle with cross
  inlet:         "rect",     // small square — curb inlet
  junction_box:  "diamond",
  pull_box:      "rect-amber", // square w/ amber accent
  valve:         "valve",    // bowtie / hexagon
  headwall:      "trapezoid",
};

/** Human-readable labels for inspector + panel. */
export const LAYER_LABEL = {
  storm: "Storm",
  sanitary: "Sanitary",
  water: "Water",
  electrical: "Electrical",
  grading: "Grading",
  paving: "Paving",
  work_limits: "Work Limits",
};

export const STRUCTURE_LABEL = {
  storm_manhole: "Storm Manhole",
  inlet: "Inlet",
  junction_box: "Junction Box",
  pull_box: "Pull Box",
  valve: "Valve",
  headwall: "Headwall",
};

export const INSTALL_LABEL = {
  proposed: "Proposed",
  in_progress: "In Progress",
  installed: "Installed",
  verified: "Field Verified",
};

const LAYER_ORDER_KEY = "fop_layer_visibility";

/** Read per-sheet layer visibility from localStorage. */
export function readLayerVisibility(sheetId) {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(`${LAYER_ORDER_KEY}_${sheetId}`);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch { return null; }
}

export function writeLayerVisibility(sheetId, map) {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(`${LAYER_ORDER_KEY}_${sheetId}`, JSON.stringify(map));
  } catch {}
}
